export const hasAlphanumericCharacter = (value: unknown): boolean =>
  typeof value === 'string' && /[\p{L}\p{N}]/u.test(value.trim());

export const MIN_DOCUMENT_NUMBER_LENGTH = 3;

export const validateDocumentNumber = (value: unknown): true | string => {
  if (!value) {
    return true;
  }

  if (String(value).trim().length < MIN_DOCUMENT_NUMBER_LENGTH) {
    return 'errors.invoiceNumberMinLength';
  }

  return hasAlphanumericCharacter(value)
    ? true
    : 'errors.invoiceNumberAlphanumeric';
};
